import { render, staticRenderFns } from "./order-list-item-softone-actions-group.vue?vue&type=template&id=4d689ab9"
import script from "./order-list-item-softone-actions-group.vue?vue&type=script&lang=js"
export * from "./order-list-item-softone-actions-group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports